import React from 'react';
class CommonValidation extends React.Component {
    // 必須バリデーション
    static Require(target) {
        if (!target) {
            return true
        }
    }
    // 文字数バリデーション(最大)
    static OverMaxLength(target, targetNum) {
        if (target == null) {
            return false
        }
        if (targetNum <= target.length) {
            return true
        }
    }
    // 文字数バリデーション(最大) 半角全角のケア
    static OverMaxLengthCareHalfHull(target, targetNum) {
      let len = 0
      for (let i = 0; i < target.length; i++) {
        (target[i].match(/[ -~]/)) ? len += 1 : len += 2
      }
      if (targetNum <= len) {
          return true
      }
  }
  // 文字数バリデーション(最小)
    static OverMinLength(target, targetNum) {
        if (targetNum >= target.length) {
            return true
        }
    }
    // 全角
    static Zenkaku(target) {
        return target.length && !target.match("^[^ -~｡-ﾟ]+$")
    }
    // 全角とスペース
    static ZenkakuAndSpace(target) {
        return target.length && !target.match("^[^-~｡-ﾟ]+$")
    }
    // 半角
    static Hankaku(target) {
        return target.length && !target.match("^[ -~｡-ﾟ]+$")
    }
    // 全角カナ
    static ZenkakuKana(target) {
        return target.length && !target.match("^[\\u30A0-\\u30FF]+$")
    }
    // 全角カナとスペース
    static ZenkakuKanaAndSpace(target) {
        return target.length && !target.match("^[\\u30A0-\\u30FF\\s]+$")
    }
    // 半角カナ
    static HankakuKana(target) {
        return target.length && !target.match("^[\\uFF61-\\uFF9F]+$")
    }
    // SLC名前カナ
    static NameKanaSLC(target) {
        return target.length && !target.match("^[\\u30A0-\\u30FF\\uFF61-\\uFF9F\\s\\uff0d\\u2010\\u2015]+$")
    }
    // 全半角カナ
    static AllKana(target) {
        return target.length && !target.match("^[\\uFF61-\\uFF9F\\u30A0-\\u30FF]+$")
    }
    // 半角数字
    static HankakuNum(target) {
      if (!target.length) return true
      return !target.match("^[0-9]+$")
    }
    // 大文字以外
    static NotUpper(target) {
        return target.length && !target.match("^[0-9a-z]*$")
    }
    // スペース不可
    static NotSpace(target) {
        return target.length && !target.match("^[^　 ]+$")
    }
    // スペース不可
    static RequiredSpace(target) {
        return target.length && !!target.match("^[^　 ]+$")
    }
    // 記号不可
    static NotSymbol(target) {
        return target.length && !target.match("^[^!\"#$%&'()*+-.,/:;<=>?@\[\\\]^_`{|}~]+$")
    }
    // メールアドレスチェック(簡易版)
    static NotMail(target) {
        return !target.match("^[ -~｡-ﾟ]+@[ -~｡-ﾟ]+$")
    }
    // // メールアドレスチェック
    // static NotMail(target) {
    //     return !target.match("^[a-zA-Z0-9_.+-]+@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,}$")
    // }
    // 漢字文字数バリデーション
    static OverMinKanji(target, num) {
        return !target.match("^[\\u4E00-\\u9FFF]{" + num + ",}$")
    }
    // 半角英数字（空文字許容）
    static NotAlphaNumAndBlank(target) {
        return !target.match(/^[0-9a-zA-Z]*$/)
    }
}
export default CommonValidation